import { render, staticRenderFns } from "./TableColumnCustomizer.vue?vue&type=template&id=1b58fd10&scoped=true&"
import script from "./TableColumnCustomizer.vue?vue&type=script&lang=js&"
export * from "./TableColumnCustomizer.vue?vue&type=script&lang=js&"
import style0 from "./TableColumnCustomizer.vue?vue&type=style&index=0&id=1b58fd10&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b58fd10",
  null
  
)

export default component.exports